import React, { useState, useEffect } from 'react';
import moment from 'moment';
import translations from '../../translations';
import Loader from '../Loader';
import EnvelopeOutline from '../icons/EnvelopeOutline';
import RawHTML from '../generic/RawHTML';
import classnames from 'classnames';
import EnvelopeOutlineOpen from '../icons/EnvelopeOutlineOpen';
import useDocumentClick from '../../utils/useDocumentClick';

import { generateRouteUrl } from '../../utils/core';
import { navigate } from '@reach/router';


import { connect } from 'react-redux';
import { fetchUserNotifications, readSingleUserNotification, readAllUserNotifications } from '../../actions/reduxActions/userNotification';

import '../../../css/user.less';

const dropDownRef = React.createRef();

export const Notification = ({ currentUser, fetchNotifications, notificationList, isLoading, readAllNotifications, readSingleNotification }) => {

    let interval = null;

    const [isDropDownOpen, toggleDropDownState] = useState(false);

    useDocumentClick(dropDownRef, () => toggleDropDownState(false));

    const getNotifications = () => {
        fetchNotifications({
            authenticationToken: currentUser.authenticationToken,
        });
    };

    useEffect(() => {
        fetchNotifications({
            authenticationToken: currentUser.authenticationToken,
        });

        interval = setInterval(getNotifications, 1000 * 60 * 60);

        return () => {
            clearInterval(interval);
        };
    }, []);

    const onClick = () => {
        if (!isDropDownOpen) {
            getNotifications();
        }

        toggleDropDownState(!isDropDownOpen);
    };

    const onShowAllClick = () => {
        readAllNotifications({ authenticationToken: currentUser.authenticationToken });
        const route = generateRouteUrl({
            tabType: 'notifications',
            tenantId: currentUser.tenantId,
        });
        navigate(route);
        toggleDropDownState(false);
    };

    // If the notification is already read, then do nothing,
    // but if it is unread, then send a request to mark it as read
    const readNotification = notification => notification.isRead ? null : readSingleNotification({
        id: notification.id,
        authenticationToken: currentUser.authenticationToken,
    });

    const hasUnreadNotifications = notificationList.some(notification => notification.isRead === false);

    const visibleNotificationCount = 5;
    const hasNotifications = notificationList.length > 0;

    const visibleNotifications = notificationList.slice(0, visibleNotificationCount);

    const classes = classnames({
        'dropdown-box': true,
        'is-open': isDropDownOpen,
    });

    return (
        <div ref={dropDownRef} className={classes}>
            <button className={`user-notification-trigger dropdown-btn ${hasUnreadNotifications ? 'has-new' : null}`} onClick={onClick}>
                <EnvelopeOutline />
            </button>
            <div className="dropdown-list-wrapper notifications-wrapper dropdown-right">
                <span className="user-notification-header">
                    { 'Notifications' }
                </span>
                {
                    isLoading && hasNotifications === false
                        ? <Loader />
                        : null
                }
                {
                    hasNotifications === false && isLoading === false
                        ? <span>{translations['no notifications']}</span>
                        : (
                            <ul className="user-notification-list">
                                {
                                    visibleNotifications.map(notification => (
                                        <li className="user-notification-item" key={notification.createdAt}>
                                            <details>
                                                <summary
                                                    className="flex"
                                                    onClick={() => readNotification(notification)}
                                                    onKeyDown={
                                                        e => e.keyCode === 13 /* If they press Enter */ ? readNotification(notification) : null
                                                    }
                                                    role="button"
                                                    tabIndex="0"
                                                >
                                                    {
                                                        notification.isRead ?
                                                            <EnvelopeOutlineOpen className="user-notification-icon" /> :
                                                            <EnvelopeOutline className="user-notification-icon" />
                                                    }
                                                    <span className="user-notification-subject">{ notification.subject }</span>
                                                    <span className="user-notification-date quiet flex-child-right">
                                                        {
                                                            moment(notification.createdAt).fromNow()
                                                        }
                                                    </span>
                                                </summary>
                                                <RawHTML HTMLContent={notification.content} className="user-notification-content" />
                                            </details>
                                        </li>
                                    ))
                                }
                            </ul>
                        )
                }
                {
                    notificationList.length > 0
                        ? <button onClick={() => onShowAllClick()} className="link-emulate">See all notifications</button>
                        : null
                }
            </div>
        </div>
    );
};

const mapStateToProps = ({
    currentUser,
    userNotifications: {
        list: notificationList,
        isLoading,
    },
}) => ({ notificationList, isLoading, currentUser });

const mapDispatchToProps = {
    fetchNotifications: fetchUserNotifications,
    readSingleNotification: readSingleUserNotification,
    readAllNotifications: readAllUserNotifications,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Notification);
